import React from 'react';
import { pathOr } from 'ramda';
import { useTheme } from 'styled-components';
import { ResponsiveContainer, PieChart as PieChartRecharts, Pie, Label, Cell } from 'recharts';
import { StyledHeading, StyledBody, LabelWrapper, StyledBodyCount } from '../styled';
const getContainerSize = (viewBox) => ({
    heightContainer: pathOr(0, ['cy'], viewBox) * 2,
    widthContainer: pathOr(0, ['cx'], viewBox) * 2
});
const CustomLabel = ({ viewBox, title, sum, count }) => {
    const { heightContainer, widthContainer } = getContainerSize(viewBox);
    return (React.createElement("foreignObject", { height: heightContainer, width: widthContainer },
        React.createElement(LabelWrapper, null,
            React.createElement(StyledHeading, null, sum),
            title && React.createElement(StyledBody, null, title),
            count && React.createElement(StyledBodyCount, null, count))));
};
export const PieChart = ({ title, dataKey = 'value', sum, data, colorMap, count, responsiveContainerConfig, pieTwoConfig, paddingAngle = 0, startAngle = 90, endAngle = -270, children, sectorSvgProps = { stroke: 'none' }, ...props }) => {
    const theme = useTheme();
    const { chartColors } = theme;
    const finalColorMap = colorMap || chartColors;
    const finalColorMapPieTwo = (pieTwoConfig === null || pieTwoConfig === void 0 ? void 0 : pieTwoConfig.colorMap) || chartColors;
    return (React.createElement(ResponsiveContainer, { ...responsiveContainerConfig },
        React.createElement(PieChartRecharts, null,
            React.createElement(Pie, { innerRadius: "75%", outerRadius: "100%", dataKey: dataKey, startAngle: startAngle, endAngle: endAngle, paddingAngle: paddingAngle, data: data, ...props },
                title && (React.createElement(Label, { offset: 0, content: React.createElement(CustomLabel, { title: title, sum: sum, count: count }) })), data === null || data === void 0 ? void 0 :
                data.map((_val, index) => {
                    return (React.createElement(Cell, { key: `cell-${index}`, fill: finalColorMap[index % finalColorMap.length], ...sectorSvgProps }));
                })),
            pieTwoConfig && (React.createElement(Pie, { ...pieTwoConfig }, data === null || data === void 0 ? void 0 : data.map((_val, index) => (React.createElement(Cell, { key: `cell-${index}`, fill: finalColorMapPieTwo[index % finalColorMapPieTwo.length], ...sectorSvgProps }))))),
            children)));
};
// TODO: Enhance function types. previousPiesData[dataKey] should be correct expression.
function calculateAngles(total, previousPiesData, dataKey) {
    if (total === 0 || previousPiesData.length === 0) {
        return { startAngle: 90, endAngle: -270 };
    }
    const countPerDegree = total / 360;
    let angularCorrection = 0;
    for (const previousData of previousPiesData) {
        if (previousData[dataKey] === 0) {
            continue;
        }
        angularCorrection += previousData[dataKey] / countPerDegree;
    }
    const startAngle = 90 - angularCorrection;
    const endAngle = startAngle - 360;
    return { startAngle, endAngle };
}
export const SumPartPieChart = ({ total, previousValues, currentValue, colorMap, dataKey = 'value', ...props }) => {
    const theme = useTheme();
    const { chartColors, chartEmptyColor = 'rgb(40 48 61 / 0.08)' } = theme;
    const colorMapForPick = colorMap || chartColors;
    const data = [{ value: currentValue }, { value: total - currentValue }];
    const { startAngle, endAngle } = calculateAngles(total, previousValues, dataKey);
    const currentValueIndex = previousValues.length;
    const finalColorMap = [colorMapForPick[currentValueIndex], chartEmptyColor];
    return (React.createElement(PieChart, { data: data, startAngle: startAngle, endAngle: endAngle, colorMap: finalColorMap, ...props }));
};
